module.exports = __webpack_public_path__ + "img/ups-cod.41c3dce6.png";